import React, { useState } from 'react';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import animate from 'utilities/animate';

const Faq = props => {
    const {question, answer} = props;


    const paragraphState_init = {
        opacity: 0,
        lineHeight: 0,
        visibility: "hidden",
        marginTop: 0,
        marginBottom: 0,
    };
    const paragraphState_final = {
        opacity: 1,
        lineHeight: 1.5,
        visibility: "visible",
        marginTop: 10,
        marginBottom: 0,
    };

    const arrowAngle_inital = 0;
    const arrowAngle_final = 90;

    const [showAnswer, set_showAnswer] = useState(false);
    const [paragraphState, set_paragraphState] = useState(paragraphState_init);
    const [arrowAngle, set_arrowAngle] = useState(arrowAngle_inital);

    const changeParagraphState = (fraction, initialState, finalState, favorInitial=true) => {
        const midState = {};
        const keys = Object.keys(initialState);
        keys.forEach(key => {
            if(typeof initialState[key] === "number")
                midState[key] = finalState[key] * fraction + initialState[key] * (1 - fraction);
            else {
                if(fraction === 0) midState[key] = favorInitial ? finalState[key] : initialState[key];
                else midState[key] = favorInitial ? initialState[key] : finalState[key];
            }
        });

        set_paragraphState(midState);
    }

    const changeArrowAngle = (fraction, initialAngle, finalAngle) => {
        const newAngle = finalAngle * fraction + initialAngle * (1 - fraction);
        set_arrowAngle(newAngle);
    }

    return(
        <div>
            <div
            onClick={() => {
                const prevShow = showAnswer;
                set_showAnswer(!prevShow);
                animate({
                    timing: t => t,
                    draw: fraction => {
                        const initial = !prevShow ? paragraphState_init : paragraphState_final;
                        const final = !prevShow ? paragraphState_final : paragraphState_init;
                        const favorInitial = !prevShow ? false : true;
                        changeParagraphState(fraction, initial, final, favorInitial);
                    },
                    duration: 200
                });
                animate({
                    timing: t => t,
                    draw: fraction => {
                        const initial = !prevShow ? arrowAngle_inital : arrowAngle_final;
                        const final = !prevShow ? arrowAngle_final : arrowAngle_inital;
                        changeArrowAngle(fraction, initial, final);
                    },
                    duration: 200
                })
            }}
            style={styles.box}>
                <div style={{width: "90%"}}>
                    <h4 style={{marginBottom: 0}}>{question}</h4>
                    <p style={paragraphState}>{answer}</p>
                </div>
                <div style={{width: "10%"}}>
                    <ArrowRightIcon style={{...styles.arrow, transform: `rotateZ(${arrowAngle}deg)`}} />
                </div>
            </div>
        </div>
    )
}

export default Faq;

const styles = {
    box: {
        background: "#F0F0F0",
        maxWidth: "900px",
        margin: "10px 10px 10px 0",
        padding: "25px",
        cursor: "pointer",
        display: "flex",
    },
    arrow: {
        float: "right",
    }
}